import { Modal } from "antd";
import React from "react";
import styles from "./index.module.scss";
import { Button } from "app/(new-pages)/components/Button/pc/index.pc";
import { useSharedData } from "bossjob-remote/dist/hooks";
import { getValueById } from "helpers/config/getValueById";
const VerifyIdentitySuccess = ({ open, onClose, dic, confirmData }) => {
  const config = useSharedData("CONFIG");
  return (
    <Modal
      open={open}
      footer={null}
      maskClosable={false}
      width={420}
      onCancel={onClose}
      centered
      title={dic?.identityVerifiedSuccessfully}
      wrapClassName={styles.wrapClassNameModal}
    >
      <p className={styles.identity}>{dic?.yourCurrentIdentity}</p>

      <p className={styles.identityDetail}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
        >
          <path
            d='M1.75 7.875C1.75 4.49226 4.49226 1.75 7.875 1.75H20.125C23.5077 1.75 26.25 4.49226 26.25 7.875V20.125C26.25 23.5077 23.5077 26.25 20.125 26.25H7.875C4.49226 26.25 1.75 23.5077 1.75 20.125V7.875Z'
            fill='#F4333D'
          />
          <path
            d='M16.6499 19.3962H11.5435C11.8973 16.9486 12.2489 14.5303 12.5991 12.112H15.5835C15.9313 14.4892 16.2866 16.9173 16.6499 19.3962ZM14.144 7.22334C14.4555 7.2226 14.7637 7.27764 15.0503 7.38545C15.3368 7.49327 15.5958 7.65142 15.811 7.85029C16.0264 8.04935 16.1941 8.28568 16.3032 8.54365C16.4122 8.80154 16.4606 9.07627 16.4458 9.35127C16.4431 9.62679 16.3783 9.89887 16.2554 10.1521C16.1324 10.4052 15.9541 10.6345 15.73 10.8259C15.5058 11.0173 15.2402 11.1674 14.9497 11.2673C14.6592 11.3672 14.3492 11.4151 14.0376 11.4079C13.4088 11.3929 12.812 11.1585 12.3784 10.7556C11.945 10.3527 11.7097 9.81432 11.7241 9.2585C11.7271 8.98333 11.7925 8.71109 11.9165 8.45869C12.0407 8.20617 12.2211 7.97759 12.4468 7.78779C12.6724 7.59799 12.9395 7.45028 13.231 7.35322C13.5224 7.25623 13.8329 7.21232 14.144 7.22334Z'
            fill='white'
          />
        </svg>

        {getValueById(config, confirmData?.new_user_identity?.id, "user_identity_lists") ||
          confirmData?.new_user_identity?.value}
      </p>
      <div className={styles.enjoy}>
        {dic?.nowYouEnjoy}
        <p>
          <span></span>
          {dic?.priorityVisibilityToEmployers}
        </p>
        <p>
          <span></span>
          {dic?.anExclusiveVerifiedBadge}
        </p>
        <p>
          <span></span>
          {dic?.higherChancesOfJobMatching}
        </p>
      </div>

      <div className={styles.footer}>
        <Button btnSize='size40' onClick={onClose}>
          {dic?.findJobsNow}
        </Button>
      </div>
    </Modal>
  );
};

export default VerifyIdentitySuccess;
